import { Button } from "@cloudscape-design/components";
import React from "react";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div
      data-testid="app-not-found"
      className="text-gray-300 text-center w-[100vw] h-[100vh] flex flex-col items-center justify-center"
    >
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-2xl mb-5">
        The page you are looking for does not exist.
      </p>
      <Button onClick={() => navigate("/")}>Go to Home</Button>
    </div>
  );
};
